import React, { Component } from 'react';

import TrafficSignsModel from './TrafficSignsModel';

import { Select } from 'antd';
const Option = Select.Option;

class TrafficSignsSelect extends Component {

  state = {
    children: []
  }

  componentWillMount() {            
    TrafficSignsModel.getAll(true)
    .then(data => {     
      var children = [];   
      data.map((child, key) => {
      return children.push(<Option key={child.serialNumber}>{child.serialNumber}</Option>);
      });
      this.setState({
        children: children
      });
    });
  }

  render() {    
    return (    
      <Select
        size="default"
        showSearch
        placeholder={this.props.placeholder ? this.props.placeholder : 'Zvolte informační tabuli'}
        optionFilterProp="children"
        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0} 
        onChange={(value) => { this.props.onChange(value) }}        
        {...this.props}>
          {this.state.children}
      </Select>
    );
  }
}

export default TrafficSignsSelect;


// WEBPACK FOOTER //
// ./src/components/TrafficSignsSelect.js